import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { usePermissions } from '../../../../user/permissions';

import { Button, ButtonDropdown, DropdownItem, Icon, WeezHeader, Tab } from '@weezevent/nacre';

export default function StatusesTransitions({ organization, flowId, index, path, children }) {
    const { t } = useTranslation();
    const permissions = usePermissions();
    const isAdmin = permissions.isAdmin();
    const history = useHistory();
    const [activeTab, setActiveTab] = React.useState(() => index);

    const panes = React.useMemo(() => {
        const items = [
            {
                id: 0,
                name: 'statuses',
                menuItem: t('ticket.moderation.statusesTransitions.tabs.statuses'),
                menuIcon: 'check-circle',
                url: `${path}/statuses`,
                restricted: false
            },
            {
                id: 1,
                name: 'transitions',
                menuItem: t('ticket.moderation.statusesTransitions.tabs.transitions'),
                menuIcon: 'transfer',
                url: `${path}/transitions`,
                restricted: false
            },
            {
                id: 2,
                name: 'actions',
                menuItem: t('ticket.moderation.statusesTransitions.tabs.actions'),
                menuIcon: 'play',
                url: `${path}/actions`,
                restricted: !isAdmin
            },
            {
                id: 3,
                name: 'conditions',
                menuItem: t('ticket.moderation.statusesTransitions.tabs.conditions'),
                menuIcon: 'controle',
                url: `${path}/conditions`,
                restricted: !isAdmin
            }
        ];
        return items.filter(it => !it.restricted);
    }, [isAdmin, path]);

    const actions = React.useMemo(() => {
        const items = [
            { name: 'statuses', label: 'addStatus', restricted: false },
            { name: 'transitions', label: 'addTransition', restricted: false },
            { name: 'actions', label: 'addAction', restricted: !isAdmin },
            { name: 'conditions', label: 'addCondition', restricted: !isAdmin }
        ];
        return items.filter(it => !it.restricted);
    }, [isAdmin, path]);

    return (
        <>
            <WeezHeader
                title={t('ticket.moderation.statusesTransitions.title')}
                rightComponent={[
                    <ButtonDropdown
                        key={0}
                        trigger={<Button primary icon={<Icon name="plus" />} label={t('ticket.common.action.add')} />}
                        items={actions.map((it, index) => (
                            // TODO Once Actions and conditions pages will ready, remove useMemo and restore items list without restrictions
                            <DropdownItem key={index} item={t(`ticket.moderation.statusesTransitions.${it.label}`)} onClick={() => history.push(`${path}/${it.name}/new`)} />
                        ))}
                    />
                ]}
            >
                <span>{t('ticket.moderation.statusesTransitions.subtitle')}</span>
            </WeezHeader>
            <Tab
                panes={panes} // TODO Once Actions and conditions pages will ready, remove useMemo and restore panes list without restrictions
                activeTab={activeTab}
                onTabSelected={tab => {
                    history.push(tab.url);
                    setActiveTab(tab.id);
                }}
            >
                {React.cloneElement(children, { organization, flowId, path })}
            </Tab>
        </>
    );
}
